"use strict";

exports.__esModule = true;
exports.ClassificationTimelineValue = void 0;
var _react = _interopRequireWildcard(require("react"));
var _TextValue = require("../../Measures/TextValue");
var _PlantStateActivitiesContext = require("../../PlantStateActivities/PlantStateActivitiesContext");
var _getPlantState = require("../../PlantStateActivities/getPlantState");
var _getPlantActivity = require("../../PlantStateActivities/getPlantActivity");
var _PlantStateActivities = require("../../PlantStateActivities");
var _excluded = ["width", "height", "value", "plantStateActivities"];
var _dec, _class, _ClassificationTimelineValue;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Displays a classification from a timeline.
 */
var ClassificationTimelineValue = exports.ClassificationTimelineValue = (_dec = _PlantStateActivitiesContext.PlantStateActivitiesContext.withContext, _dec(_class = (_ClassificationTimelineValue = /*#__PURE__*/function (_Component) {
  function ClassificationTimelineValue() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ClassificationTimelineValue, _Component);
  var _proto = ClassificationTimelineValue.prototype;
  _proto.abbreviateStateName = function abbreviateStateName(state) {
    if (state.id === "downtime.unplanned") {
      return "UDT";
    }
    if (state.id === "downtime.planned") {
      return "PDT";
    }
    return state.name;
  };
  _proto.render = function render() {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      value = _this$props.value,
      allPlantStateActivities = _this$props.plantStateActivities,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var plantStateActivities = (0, _PlantStateActivities.getEnabledPlantStateActivities)(allPlantStateActivities);
    var formattedValue = "-";
    if (value && value.value) {
      var state = (0, _getPlantState.getPlantState)(plantStateActivities.states, value.value.state);
      var activity = value.value.activity ? (0, _getPlantActivity.getPlantActivity)(plantStateActivities.activities, value.value.activity) : undefined;
      formattedValue = activity ? this.abbreviateStateName(state) + ": " + activity.name : state.name;
    }
    return /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, _extends({
      width: width,
      height: height,
      value: formattedValue
    }, extra));
  };
  return ClassificationTimelineValue;
}(_react.Component), _ClassificationTimelineValue.defaultProps = {
  plantStateActivities: undefined
}, _ClassificationTimelineValue)) || _class);